import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyTripsGridComponent } from './my-trips-grid.component';
import { AgGridModule } from 'ag-grid-angular';
import { MyTripsGridService } from './my-trips-grid.service';
import { EditReservationModule } from 'app/pages/trip-reservations/edit-reservation/edit-reservation.module';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';
import { BtnsForGridModule } from '../btns-for-grid/btns-for-grid.module';


@NgModule({
  imports: [
    CommonModule,
    AgGridModule,
    EditReservationModule,
    Trip2ThemeModule,
    BtnsForGridModule
  ],
  declarations: [MyTripsGridComponent],
  exports: [MyTripsGridComponent],
  providers: [MyTripsGridService]
})
export class MyTripsGridModule { }



// WEBPACK FOOTER //
// ./src/app/utils/my-trips-grid/my-trips-grid.module.ts